/**
 * Featured Reviews Section JavaScript
 * Handles carousel initialization if needed
 */

(function() {
  'use strict';

  // Initialize featured reviews section
  function initFeaturedReviews() {
    // The slider-element custom element handles carousel functionality automatically
    // No additional initialization needed unless custom behavior is required
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedReviews);
  } else {
    initFeaturedReviews();
  }
})();
